import { SVGProps } from "react"
import { iconsPath } from "../../utils/path"

type IconProps = {
    name: string
    color?: string
    size?: number
    onClick?: (event: React.MouseEvent<SVGSVGElement>) => void
} & SVGProps<SVGSVGElement>

const Icon = ({
    name,
    color = "black",
    size = 24,
    onClick,
    ...rest
}: IconProps) => {
    return (
        <svg
            role="img"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill={color}
            {...rest}
            aria-label={name}
            onClick={onClick}
        >
            <use href={`${iconsPath}#${name}`} />
            <title>{name}</title>
        </svg>
    )
}

export default Icon
